import axiosInstance from "../backend/axiosInstance";

export const LeagueIcons = {};
export const LeagueIconsMeta = {};

let fetched = false;

export async function fetchLeagueIcons() {
    if (fetched) return;
    fetched = true;

    try {
        const response = await axiosInstance.get("/league-icons/");

        response.data.forEach((item) => {
            LeagueIcons[item.leagueName] = item.link;

            LeagueIconsMeta[item.leagueName] = {
                link: item.link,
                dark: item.dark,
            };
        });
    } catch (error) {
        console.error("Error fetching League logos:", error);
    }
}

export function LeagueIconComponent({ leagueName }) {
    return (
        <img
            src={LeagueIcons[leagueName]}
            style={{
                filter: LeagueIconsMeta[leagueName]?.dark ? "invert(1)" : "none"
            }}
            alt={leagueName}
            className="small-image"
        />
    );
}